// extracted by mini-css-extract-plugin
export var icon = "style-module--icon--195da";
export var label = "style-module--label--7f57c";
export var name = "style-module--name--cb411";
export var save = "style-module--save--33a74";